// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4cc49fbc","456":"a9a81b8e","753":"d916f2cc","833":"62905c1c"}[chunkId] + ".chunk.js";
};